'use client';

import { type FC, useState } from 'react';

import type { ReferralDataItem } from '@/api/cms/referralProgram';
import { ScQuestionAnswer } from '@/components/footerStaticPages/faq/styled';
import { QuestionAnswerItem } from '@/components/QuestionAnswerItem';
import { ThemeMode } from '@/helpers/enums';
import { ScFAQSection } from './styled';

interface FAQSectionProps {
  items: ReferralDataItem[];
}

export const FAQSection: FC<FAQSectionProps> = ({ items }) => {
  const [activeAnswerItem, setActiveAnswerItem] = useState<number | null>(null);

  return (
    <ScFAQSection>
      <ScQuestionAnswer>
        <div className="questions">
          {items.map(({ question, answer }, index) => (
            <QuestionAnswerItem
              description={answer}
              handleOpen={() =>
                setActiveAnswerItem(index === activeAnswerItem ? null : index)
              }
              isOpen={index === activeAnswerItem}
              key={index}
              mode={ThemeMode.Dark}
              title={question}
            />
          ))}
        </div>
      </ScQuestionAnswer>
    </ScFAQSection>
  );
};
